import { render, staticRenderFns } from "./ReceiveCoin.vue?vue&type=template&id=ea749422&"
import script from "./ReceiveCoin.vue?vue&type=script&lang=js&"
export * from "./ReceiveCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports